import { render, staticRenderFns } from "./print.vue?vue&type=template&id=0c38604d&scoped=true"
import script from "./print.vue?vue&type=script&lang=js"
export * from "./print.vue?vue&type=script&lang=js"
import style0 from "./print.vue?vue&type=style&index=0&id=0c38604d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38604d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c38604d')) {
      api.createRecord('0c38604d', component.options)
    } else {
      api.reload('0c38604d', component.options)
    }
    module.hot.accept("./print.vue?vue&type=template&id=0c38604d&scoped=true", function () {
      api.rerender('0c38604d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/print.vue"
export default component.exports